import * as React from "react"
import { cn } from "@cleverbooking-fe-monorepo/shared-utils"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-11 w-full rounded-xl border-2 border-border bg-background px-4 py-2 text-sm text-foreground placeholder:text-muted-foreground transition-all duration-200",
          "focus:border-blue-500 focus:ring-4 focus:ring-blue-100 dark:focus:ring-blue-900 focus:outline-none",
          "hover:border-muted-foreground/40 shadow-sm hover:shadow-md",
          "disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground disabled:opacity-60",
          "aria-invalid:border-red-500 aria-invalid:focus:ring-red-100",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"
